import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { SubmissionInfoItem } from '../../../../models/shared/submission-info-item';
import { SubmissionDetailsFieldChangeTypeEnum } from './submission-details-field-change-type.enum';

@Component({
  selector: 'app-employer-contact-submission-details-field-change',
  templateUrl: './employer-contact-submission-details-field-change.component.html',
  styleUrls: ['./employer-contact-submission-details-field-change.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class EmployerContactSubmissionDetailsFieldChangeComponent implements OnChanges {
  @Input() detailsChanges: SubmissionInfoItem[] = [];
  @Input() changeType!: SubmissionDetailsFieldChangeTypeEnum;

  public label: string = '';
  public hasChanges: boolean = true;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.changeType) {
      this.label =
        this.changeType === SubmissionDetailsFieldChangeTypeEnum.Previous ? $localize`Previous` : $localize`New`;
    }
    if (changes.detailsChanges) {
      this.hasChanges = this.detailsChanges?.some(change => change.hasChanged);
    }
  }

  protected readonly SubmissionDetailsFieldChangeTypeEnum = SubmissionDetailsFieldChangeTypeEnum;
}
